

define(['angular', 'squid/index', 'text!./template.html', 'xo-models/src/checkout/index', 'xo-ui-components/src/generic-message/directive'], function (angular, squid, template) {
    return angular.module('hermes.page.xo-generic-message.directive', ['squid', 'xomodel.checkout', 'xo-generic-message.directive']).directive('xoGenericMessagePage', function ($rootScope) {

        return {
            template: template,

            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {

                $scope.token = $rootScope.token;
                angular.element('#defaultCancelLink').hide();

                var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $rootScope.$on('$destroy', stateChangeStart);
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/directive.js
// module id = ./pages/xo-generic-message/directive.js
// module chunks = 0